module.exports = "https://coursera_assets.s3.amazonaws.com/images/1c2b91f8e003cf6a454bd874c2c6505c.svg";